/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Recursively walks a Builder.io blocks tree and returns true if any node uses
 * the given component by name. Used to make page-level decisions (e.g. hide
 * the global header) based on which custom components live on the page,
 * without requiring marketing to set anything in Builder.
 */
const hasBuilderComponent = (blocks: any[] | undefined | null, componentName: string): boolean => {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return false;
  }

  return blocks.some(block => {
    if (block?.component?.name === componentName) {
      return true;
    }
    if (hasBuilderComponent(block?.children, componentName)) {
      return true;
    }
    if (hasBuilderComponent(block?.component?.options?.blocks, componentName)) {
      return true;
    }

    return false;
  });
};

export default hasBuilderComponent;
